export interface CheckoutTokenResponse {
  externalApiToken: string;
}
